module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race",
    style: ({
      'background-image': _vm.getBackgroundImage()
    })
  }, [_c('div', {
    staticClass: "race__overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "race__info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n      " + _vm._s(_vm.info.name) + "\n      "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n      " + _vm._s(_vm._f("date")(_vm.info.date)) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "type"
  }, [_vm._v("\n      " + _vm._s(_vm.info.type) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "race__button"
  }, [_c('router-link', {
    staticClass: "btn btn--primary",
    attrs: {
      "to": {
        path: _vm.path
      }
    }
  }, [_vm._v("VIEW")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-750f148a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Race/RaceItem.vue
// module id = 1840
// module chunks = 1